import React from 'react';
import WithConsumer from "../context/WithConsumer";


/**
 *
 */
class Post extends React.PureComponent {

    render = () => {

        const {context, post} = this.props;
        const slug = !post ? undefined : post.slug;
        const data = context.getPostData(slug);

        if (!data) {
            return (<div/>);
        }

        return (
            <div className='Container'>
                {this.props.heading && (
                    <div className='Post__heading'>
                        <h1>{data.title.rendered}</h1>
                    </div>
                )}
                <div className='Post'>
                    <div
                        className='Page__panel'
                        dangerouslySetInnerHTML={{__html: data.acf.panel}}
                    />
                    <div
                        className='Page__content'
                        dangerouslySetInnerHTML={{__html: data.content.rendered}}
                    />
                </div>
            </div>
        );
    };
}

export default WithConsumer(Post);